import { useMutation, useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { billingService } from '~/services/billingAPI';
import {
  ApiQueryFnData,
  formatErrorPayload,
  UseApiMutationOptions,
  UseApiQueryOptions,
  validateApiResponse,
} from '../utils';

const ROOT_KEY = 'usage';
const getQueryKey = (organizationId: string) => [ROOT_KEY, organizationId];

export const useUsageQuery = (
  organizationId: string,
  options?: UseApiQueryOptions<typeof billingService.getUsage>,
) => {
  const dispatch = useDispatch();

  return useQuery(
    getQueryKey(organizationId),
    async () => validateApiResponse(await billingService.getUsage(organizationId)).data,
    {
      onError: (error) => dispatch(formatErrorPayload(error)),
      ...options,
    },
  );
};

export const useEditUsageLimitMutation = <T extends typeof billingService.updateUsageLimit>(
  options?: UseApiMutationOptions<T>,
) => {
  const dispatch = useDispatch();

  return useMutation(
    async ({ organizationId, update }: { organizationId: string; update: ApiQueryFnData<T> }) =>
      validateApiResponse(await billingService.updateUsageLimit(organizationId, update)).data,
    {
      onError: (error) => dispatch(formatErrorPayload(error)),
      ...options,
    },
  );
};
